module.exports = __webpack_public_path__ + "img/photo-67.aa670ad9.webp";